import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/revision-record/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { RevisionRecordFeature } from '@framework/workbench/ui/revision-record/revision-record-feature';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

@Controller({ menuItems: MENU_CONFIGS })
export class RevisionRecordController {
    constructor(private readonly feature: RevisionRecordFeature) {
    }

    @Menu(ActionType.REVISION_RECORD, 'onClick')
    public showRevisionRecord() {
        this.feature.showRevisionRecord();
    }

    // 没有编辑权限时置灰
    @Menu(ActionType.REVISION_RECORD, 'shouldDisabled')
    public disableRevisionRecord() {
        return !global.clientVars?.privilegeAttribute?.can_edit;
    }

    @Menu(ActionType.REVISION_RECORD, 'shouldHide')
    public hideRevisionRecord() {
        return !(appConfigInstance.getConfig('custom.feature.history.version' as any) ?? true);
    }
}
